import style from '../style/Account.module.scss';
import className from 'classnames/bind';
import {
	useCurrentUser,
} from "~/hooks";
import {globalNavigate} from "../../../routes/GlobalHistory";
import {Tabs} from "antd";
import {useDispatch} from "react-redux";

import {
	Button,
	Icon
} from "~/components";
import {authActions} from "../../../reduxs/Auth/authSlice";
const cn = className.bind(style);

function AccountHeader({active}) {

	const currentUser = useCurrentUser();

	const itemsTab = [
		{
			key: 'info',
			label: 'Thông tin',
		},
		{
			key: 'password',
			label: 'Mật khẩu',
		},
	];

	const dispatch = useDispatch();

	const handleLogout = () => {
		localStorage.clear();
		dispatch(authActions.logout());
		globalNavigate(process.env.REACT_APP_HOMEPAGE+"/login");
	}

	const handleTabChange = (key) => {
		globalNavigate(`${process.env.REACT_APP_HOMEPAGE}/account/${key}`);
	};

	return (
		<section className={cn('profile-heading')}>
			<div className={cn('profile-name')}>
				<p className={cn('profile-name-main', 'text-xl')}>{currentUser.firstname} {currentUser.lastname}</p>
				<p className={cn('profile-name-mini', 'text-sm')}>@{currentUser.username}</p>
			</div>
			<div className="text-center">
				<Button background red leftIcon={Icon.logout} onClick={handleLogout}>Đăng xuất</Button>
			</div>
			<Tabs
				defaultActiveKey={active}
				items={itemsTab}
				onChange={handleTabChange}
			/>
		</section>
	)
}

export default AccountHeader;